module.exports = __webpack_public_path__ + "static/media/017.4da2525d.jpg";